import { createApi } from '@reduxjs/toolkit/query/react';

import { apiRoreSessions } from '~constants/api';

import { rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';
import { RoreSession } from '~rore/types';

import { getMockSession } from './mockData';

// TODO: TAV-2033 — Set to false and remove mockData import once TAV-2025 API is deployed
const USE_MOCK_DATA = true;

export const sessionsApi = createApi({
  reducerPath: 'roreSessionsApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiRoreSessions }),
  tagTypes: ['sessions'],
  endpoints: (builder) => ({
    getRoreSession: builder.query<RoreSession, string>({
      ...(USE_MOCK_DATA
        ? {
            queryFn: (id) => {
              const session = getMockSession(id);
              if (!session) {
                return { error: { status: 404, message: 'Session not found', data: undefined } };
              }
              return { data: session };
            },
          }
        : {
            query: (id) => ({ url: `/${id}`, method: 'GET' }),
            transformResponse: (payload) => unwrap<RoreSession>(payload),
          }),
      providesTags: (_result, _error, id) => [{ type: 'sessions', id }],
    }),
  }),
});

export const { useGetRoreSessionQuery } = sessionsApi;
